<a
    class="vismaicon vismaicon-filled vismaicon-info"
    [ngClass]="'vismaicon-' + iconSize"
    [attr.aria-label]="text | translate"
    container="body"
    containerClass="warning"
    [outsideClick]="true"
    [placement]="position"
    [popover]="text | translate"
    triggers="hover"
></a>
